import { useState } from "react";
import { Dialog, DialogContent } from "@bookdental/ui";
import { FileCheck, LogOut } from "lucide-react";
import { toast } from "sonner";
import { PAGINAS_DOS_DOCUMENTOS } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { env } from "@/lib/env";

/**
 * Gate: os Termos de Uso e a Política de Privacidade mudaram (ou a conta entrou pelo Google sem passar
 * pelo cadastro) e falta aceitar a versão vigente. O aceite fica gravado com data e IP.
 */
export function AceiteDosDocumentosModal({ versao }: { versao: string }) {
  const { signOut } = useAuth();
  const utils = trpc.useUtils();
  const [marcado, setMarcado] = useState(false);
  const aceitar = trpc.me.aceitarDocumentos.useMutation({
    onSuccess: () => utils.me.current.invalidate(),
    onError: (e) => toast.error(e.message || "Não foi possível registrar o aceite."),
  });
  const link = "font-medium text-brand-700 underline-offset-2 hover:underline";

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent
        hideClose
        className="flex w-full max-w-md flex-col items-center gap-0 overflow-hidden p-8 text-center sm:rounded-3xl"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-100 text-brand-700">
          <FileCheck className="h-7 w-7" />
        </span>
        <h1 className="mt-4 text-xl font-bold text-zinc-900">Termos e privacidade</h1>
        <p className="mt-2 text-sm text-zinc-500">
          Para continuar usando o DentalBook, leia e aceite a versão atual dos{" "}
          <a href={`${env.landingUrl}${PAGINAS_DOS_DOCUMENTOS.termos}`} target="_blank" rel="noreferrer" className={link}>
            Termos de Uso
          </a>{" "}
          e da{" "}
          <a href={`${env.landingUrl}${PAGINAS_DOS_DOCUMENTOS.privacidade}`} target="_blank" rel="noreferrer" className={link}>
            Política de Privacidade
          </a>
          .
        </p>

        <label className="mt-5 flex items-start gap-2 text-left text-sm text-zinc-600">
          <input type="checkbox" checked={marcado} onChange={(e) => setMarcado(e.target.checked)} className="mt-0.5 h-4 w-4 rounded border-zinc-300" />
          Li e concordo com os Termos de Uso e a Política de Privacidade.
        </label>

        <button
          type="button"
          onClick={() => aceitar.mutate({ versao })}
          disabled={!marcado || aceitar.isPending}
          className="mt-6 inline-flex h-11 w-full items-center justify-center rounded-md bg-brand-600 text-sm font-semibold text-white shadow-md transition-colors hover:bg-brand-700 disabled:opacity-60"
        >
          {aceitar.isPending ? "Registrando..." : "Aceitar e continuar"}
        </button>
        <button
          type="button"
          onClick={signOut}
          className="mt-3 inline-flex items-center gap-1.5 text-sm text-zinc-500 transition-colors hover:text-zinc-700"
        >
          <LogOut className="h-4 w-4" />
          Sair
        </button>
      </DialogContent>
    </Dialog>
  );
}
